import { useState } from 'react';

import { i18n } from '@debijenkorf/dbk-common';

import { CarouselSection } from '@/components/Carousels/CarouselSection';
import type { CarouselProductMapperProps } from '@/services/mappers/common/carouselProductMapper';
import { removeRecentlyViewedProduct } from '@/utilities/storage';
import { PDP_TRACK_LOCATION } from '@/utilities/tracking';

type RecentProductCarouselProps = {
  products?: CarouselProductMapperProps[];
  location?: string;
};

export const RecentProductCarousel = ({
  products = [],
  location = PDP_TRACK_LOCATION,
}: RecentProductCarouselProps) => {
  const [deletedCodes, setDeletedCodes] = useState<string[]>([]);

  const handleDeleteItem = (productCode: string) => {
    removeRecentlyViewedProduct(productCode);
    setDeletedCodes(codes => [...codes, productCode]);
  };

  const recentProducts = products.filter(({ code }) => !deletedCodes.includes(code));

  return (
    <CarouselSection
      title={i18n.t('responsive-assets.landing.product.recentlyViewed')}
      products={recentProducts}
      itemPrefix="recent-product-carousel"
      listName="carousel_recently_viewed"
      location={location}
      onDeleteItem={handleDeleteItem}
    />
  );
};
